const initialState = {
    trailBalanceList: [],
    isFetchingTrailBalance: false,
};

const TrailBalanceReducer = (state = initialState, action) => {
    switch (action.type) {

        case "REQUEST_TRIAL_BALANCE_SEARCH":
            return { ...state, isFetchingTrailBalance: true };
        case "SUCCESS_TRIAL_BALANCE_SEARCH":
            return { ...state, trailBalanceList: action.payload, isFetchingTrailBalance: false };
        case "ERROR_TRIAL_BALANCE_SEARCH":
            return { ...state, isFetchingTrailBalance: false };


        default:
            return state;
    }
};

export default TrailBalanceReducer;